<!--商品下提示词 砍接团券-->
<template>
    <div>
        <div class="recommend-fine-tips" v-for="(tag, index) in discount" @click="goDetail(tag.url)">
            <div class="recommend-tip-color recommend-tip-red" :style="'background: '+tag.color">{{tag.tag}}</div>
            <div>{{tag.title}}</div>
            <img class="icon-right" src="../assets/images/icon-right.png" alt="">
        </div>
    </div>
</template>
<style scope>
    .recommend-fine-tips {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        /*padding: 0.05rem 0;*/
        position: relative;
        margin-top: 10px;
    }

    .recommend-tip-color {
        width: 14px;
        height: 14px;
        text-align: center;
        line-height: 14px;
        background: rgba(39, 48, 64, 1);
        border-radius: 0.04rem;
        color: #fff;
        margin-right: 0.05rem;
        overflow: hidden;
    }

    .recommend-tip-text {
        color: #666;
    }

    .recommend-tip-text span {
        color: #FD2840;
    }

    .recommend-tip-green {
        background-color: #42BD56;
    }

    .recommend-tip-origin {
        background-color: #FF7500;
    }

    .recommend-tip-red {
        background-color: #FF5A5F;
    }

    .icon-right {
        position: absolute;
        right: 0.2rem;
        top: 0.05rem;
        width: 16px;
        height: 16px;
    }
</style>

<script>
    export default {
        name: 'TuanItem1',
        props: [
            'showRight',
            "discount",
        ],
        data() {
            return {}
        },
        mounted: function () {
        },
        methods: {
            goDetail(url) {
                console.log(url)
                this.$router.push({
                    path: url.name,
                    query: {
                        id: url.query.id
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// GoodsDetailTips.vue?62898184